/* Tysk katalog for locale-projects-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'pj.tab.time': 'Zeiterfassung',
  'pj.tab.overview': 'Übersicht',
  'pj.tab.settings': 'Einstellungen',
  'pj.day.mon': 'Mo',
  'pj.day.tue': 'Di',
  'pj.day.wed': 'Mi',
  'pj.day.thu': 'Do',
  'pj.day.fri': 'Fr',
  'pj.day.sat': 'Sa',
  'pj.day.sun': 'So',
  'pj.person.fallback': 'dich',
  'pj.time.title': 'Zeiterfassung für {name}',
  'pj.week.label': 'KW {week}',
  'pj.week.word': 'Woche',
  'pj.week.pick': 'Woche wählen',
  'pj.week.current': 'Diese Woche',
  'pj.week.back': 'Drei Wochen zurück',
  'pj.week.forward': 'Drei Wochen vor',
  'pj.week.prev': 'Vorherige Woche',
  'pj.week.next': 'Nächste Woche',
  'pj.month.prev': 'Vorheriger Monat',
  'pj.month.next': 'Nächster Monat',
  'pj.month.entries': 'Erfasste Stunden im {month}',
  'pj.month.dayHours': '{hours} erfasst',
  'pj.view.day': 'Tag',
  'pj.view.week': 'Woche',
  'pj.day.empty': 'An diesem Tag sind keine Stunden erfasst.',
  'pj.table.projectActivity': 'Projekt / Tätigkeit',
  'pj.table.sum': 'Summe',
  'pj.table.hours': 'Stunden',
  'pj.row.new': 'Neue Zeile',
  'pj.row.add': 'Hinzufügen',
  'pj.row.remove': 'Zeile entfernen',
  'pj.row.pickBoth': 'Projekt und Tätigkeit wählen',
  'pj.select.project': 'Projekt wählen …',
  'pj.select.activity': 'Tätigkeit wählen …',
  'pj.select.projectSearch': 'Projekt suchen …',
  'pj.select.activitySearch': 'Tätigkeit suchen …',
  'pj.select.projectEmpty': 'Keine Projekte entsprechen der Suche.',
  'pj.select.activityEmpty': 'Keine Tätigkeiten entsprechen der Suche.',
  'pj.project.createAction': 'Neues Projekt erstellen',
  'pj.activity.createAction': 'Neue Tätigkeit erstellen',
  'pj.activity.none': 'Das Projekt hat noch keine Tätigkeiten. Erstelle hier eine.',
  'pj.lock.state.done': 'Die Zeiterfassung ist bis einschließlich {date} als fertig markiert.',
  'pj.lock.state.open': 'Die Zeiterfassung ist nicht als fertig markiert',
  'pj.lock.markWeek': 'Bis einschließlich KW {week} als fertig markieren',
  'pj.lock.undo': 'Rückgängig',
  'pj.lock.done': 'Die Zeiterfassung ist bis einschließlich KW {week} als fertig markiert',
  'pj.lock.undone': 'Die Zeiterfassung ist wieder geöffnet',
  'pj.entry.newTitle': 'Neue Zeiterfassung',
  'pj.entry.editTitle': 'Zeiteintrag bearbeiten',
  'pj.entry.invoicedLocked': 'Die Stunden sind abgerechnet und können nicht geändert werden. Lösche den Rechnungsentwurf oder schreibe ihm eine Gutschrift, um sie freizugeben.',
  'pj.entry.periodLocked': 'Die Zeiterfassung für diesen Zeitraum ist als fertig markiert.',
  'pj.entry.invoicedShort': 'Abgerechnet',
  'pj.field.project': 'Projekt',
  'pj.field.activity': 'Tätigkeit',
  'pj.field.hours': 'Anzahl Stunden',
  'pj.field.date': 'Datum',
  'pj.field.description': 'Beschreibung',
  'pj.field.descriptionHint': 'Wofür wurden die Stunden verwendet? Der Text wird in die Rechnung übernommen.',
  'pj.field.name': 'Name',
  'pj.field.number': 'Nummer',
  'pj.field.customer': 'Kunde',
  'pj.field.contact': 'Ansprechpartner',
  'pj.field.optional': 'Optional',
  'pj.field.defaultActivity': 'Standardtätigkeit',
  'pj.field.product': 'Produkt',
  'pj.field.rate': 'Stundensatz',
  'pj.field.start': 'Beginn',
  'pj.field.end': 'Ende',
  'pj.field.color': 'Farbe',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Stundenübersicht',
  'pj.overview.week': 'Wochenübersicht',
  'pj.overview.month': 'Monatsübersicht',
  'pj.overview.reports': 'Berichte',
  'pj.overview.total': 'Summe erfasst',
  'pj.overview.billable': '{hours} abrechenbar',
  'pj.overview.weekEntries': 'Erfasste Stunden in KW {week}',
  'pj.overview.empty': 'Keine Stunden im Zeitraum erfasst',
  'pj.overview.emptyTitle': 'Keine Stunden',
  'pj.filter.all': 'Alle',
  'pj.filter.period': 'Zeitraum',
  'pj.filter.billing': 'Abrechnung',
  'pj.filter.billable': 'Abrechenbar',
  'pj.filter.nonBillable': 'Nicht',
  'pj.filter.invoicedLabel': 'Abgerechnet',
  'pj.filter.invoiced': 'Abgerechnet',
  'pj.filter.open': 'Nicht abgerechnet',
  'pj.report.title': 'Erfasste Stunden {from} – {to}',
  'pj.report.emptyTitle': 'Keine Einträge',
  'pj.report.emptyText': 'Keine Stunden im gewählten Zeitraum und Filter.',
  'pj.report.print': 'Drucken',
  'pj.report.pdf': 'Als PDF herunterladen',
  'pj.report.pdfTitle': 'Stundenbericht',
  'pj.report.pdfError': 'Der Bericht konnte nicht heruntergeladen werden.',
  'pj.report.pdfUnavailable': 'Das Berichts-PDF ist nicht mit dem Backend verbunden.',
  'pj.report.opening': 'Druckansicht wird geöffnet …',
  'pj.basis.title': 'Rechnungsgrundlage',
  'pj.basis.projectName': 'Projektname',
  'pj.basis.searchPlaceholder': 'Projekt, Kunde …',
  'pj.basis.summary': '{count} nicht abgerechnete Einträge von {from} bis {to}',
  'pj.basis.selected': 'Ausgewählt',
  'pj.basis.costs': 'Auslagen zur Weiterberechnung',
  'pj.basis.costText': 'Auslage',
  'pj.basis.costSource': 'Quelle',
  'pj.basis.costAmount': 'Betrag',
  'pj.basis.costEmployee': 'Mitarbeiterauslage · {name}',
  'pj.basis.costPurchase': 'Gebuchter Einkauf',
  'pj.basis.timesheet': 'Stundenzettel als Anhang erstellen',
  'pj.basis.create': 'Rechnungsentwurf erstellen',
  'pj.basis.created': 'Rechnungsentwurf für {project} erstellt',
  'pj.basis.pickOne': 'Wähle mindestens einen Eintrag',
  'pj.basis.error': 'Der Rechnungsentwurf konnte nicht erstellt werden.',
  'pj.basis.emptyTitle': 'Keine nicht abgerechneten Stunden',
  'pj.basis.emptyText': 'Alles ist abgerechnet, oder auf Projekten mit Kunde wurden noch keine abrechenbaren Stunden erfasst.',
  'pj.cost.tab': 'Auslagen',
  'pj.cost.title': 'Projektauslagen',
  'pj.cost.party': 'Mitarbeiter / Lieferant',
  'pj.cost.voucher': 'Beleg',
  'pj.cost.openVoucher': 'Beleg ansehen',
  'pj.cost.noVoucher': 'Der Beleg ist nicht verfügbar',
  'pj.cost.noVoucherHelp': 'Mit diesen Kosten ist keine Datei verknüpft.',
  'pj.cost.noVoucherShort': 'Ohne Beleg',
  'pj.cost.pending': 'Zur Freigabe',
  'pj.cost.invoiced': 'Abgerechnet',
  'pj.cost.notBillable': 'Nicht abrechenbar',
  'pj.cost.toInvoice': 'Zur Abrechnung',
  'pj.cost.searchLabel': 'Suchen',
  'pj.cost.searchPlaceholder': 'Beschreibung, Mitarbeiter, Lieferant …',
  'pj.cost.openSum': '{amount} zur Abrechnung',
  'pj.cost.totalAll': 'Summe aller Treffer',
  'pj.cost.emptyTitle': 'Keine Auslagen',
  'pj.cost.emptyText': 'Noch sind keine Kosten mit einem Projekt verknüpft. Belege werden im Posteingang, beim Einkauf oder beim Einreichen der Auslage durch den Mitarbeiter mit einem Projekt verknüpft.',
  'pj.billing.always': 'Immer',
  'pj.billing.ask': 'Fragen',
  'pj.billing.never': 'Nie',
  'pj.activity.newTitle': 'Neue Tätigkeit',
  'pj.activity.editTitle': 'Tätigkeit bearbeiten',
  'pj.activity.namePlaceholder': 'Z. B. Beratungsleistung',
  'pj.activity.noProduct': 'Keins',
  'pj.activity.productHint': 'Die Stunden werden als „{product}“ abgerechnet und auf Konto {account} gebucht.',
  'pj.activity.noProductHint': 'Ohne Produkt werden die Stunden als Dienstleistungsumsatz auf Konto 3020 mit dem Standard-MwSt.-Satz gebucht.',
  'pj.activity.rateHint': 'Ohne MwSt. Bleibt das Feld leer, wird der Produktpreis verwendet.',
  'pj.activity.neverHint': 'Die Stunden bleiben außerhalb der Rechnungsgrundlage. Verwende dies für Urlaub und interne Arbeit.',
  'pj.project.newTitle': 'Neues Projekt erstellen',
  'pj.project.newShort': 'Neues Projekt',
  'pj.project.editTitle': 'Projekt bearbeiten',
  'pj.project.numberHint': 'Vorschlag: {number}',
  'pj.project.customerHint': 'Ohne Kunde können die Stunden nicht abgerechnet werden.',
  'pj.project.noCustomer': 'Kein Kunde (internes Projekt)',
  'pj.project.closed': 'Abgeschlossen',
  'pj.settings.title': 'Einstellungen für die Zeiterfassung',
  'pj.settings.activities': 'Tätigkeiten',
  'pj.settings.projects': 'Projekte',
  'pj.settings.noActivitiesTitle': 'Noch keine Tätigkeiten',
  'pj.settings.noActivitiesText': 'Die Tätigkeit bestimmt den Stundensatz und als welches Produkt die Stunden abgerechnet werden.',
  'pj.settings.noProjectsFirst': 'Erstelle zuerst ein Projekt.',
  'pj.settings.noProjectsTitle': 'Noch keine Projekte',
  'pj.settings.noProjectsText': 'Erstelle ein Projekt, um mit der Zeiterfassung zu beginnen.',
  'pj.toast.entrySaved': 'Die Stunden sind erfasst',
  'pj.toast.entryUpdated': 'Der Zeiteintrag wurde aktualisiert',
  'pj.toast.entryDeleted': 'Der Zeiteintrag wurde gelöscht',
  'pj.toast.activitySaved': 'Die Tätigkeit wurde gespeichert',
  'pj.toast.activityDeleted': 'Die Tätigkeit wurde gelöscht',
  'pj.toast.projectSaved': 'Das Projekt wurde gespeichert',
  'pj.toast.projectDeleted': 'Das Projekt wurde gelöscht',
  'pj.error.saveEntry': 'Der Zeiteintrag konnte nicht gespeichert werden.',
  'pj.error.deleteEntry': 'Der Zeiteintrag konnte nicht gelöscht werden.',
  'pj.error.saveRows': 'Die Zeilen konnten nicht aktualisiert werden.',
  'pj.error.lock': 'Die Sperre konnte nicht aktualisiert werden.',
  'pj.error.saveActivity': 'Die Tätigkeit konnte nicht gespeichert werden.',
  'pj.error.deleteActivity': 'Die Tätigkeit konnte nicht gelöscht werden.',
  'pj.error.saveProject': 'Das Projekt konnte nicht gespeichert werden.',
  'pj.error.deleteProject': 'Das Projekt konnte nicht gelöscht werden.',
  'pj.validation.projectName': 'Das Projekt braucht einen Namen.',
  'pj.validation.endBeforeStart': 'Das Enddatum darf nicht vor dem Startdatum liegen.',
  'pj.validation.activityName': 'Die Tätigkeit braucht einen Namen.',
  'pj.validation.activityProject': 'Die Tätigkeit muss zu einem Projekt gehören.',
  'pj.validation.entryDate': 'Der Zeiteintrag braucht ein Datum.',
  'pj.validation.entryHours': 'Die Anzahl der Stunden muss größer als 0 sein.',
  'pj.validation.entryHoursMax': 'Ein einzelner Eintrag darf 24 Stunden nicht überschreiten.',
  'pj.validation.entryNotFound': 'Der Zeiteintrag wurde nicht gefunden.',
  'pj.validation.entryInvoiced': 'Der Zeiteintrag ist bereits abgerechnet und kann nicht geändert werden.',
  'pj.validation.periodLocked': 'Die Zeiterfassung für diesen Zeitraum ist als fertig markiert.',
  'svc.projectNotFound': 'Das Projekt wurde nicht gefunden.',
  'svc.projectNumberTaken': 'Die Projektnummer wird bereits verwendet.',
  'svc.projectHasHours': 'Für das Projekt sind Stunden erfasst. Markiere es als abgeschlossen, statt es zu löschen.',
  'svc.projectClosed': 'Das Projekt ist abgeschlossen und kann keine neuen Stunden erhalten.',
  'svc.projectNeedsCustomer': 'Das Projekt braucht einen Kunden, bevor die Stunden abgerechnet werden können.',
  'svc.activityNotFound': 'Die Tätigkeit wurde nicht gefunden.',
  'svc.activityHasHours': 'Für die Tätigkeit sind Stunden erfasst, daher kann sie nicht gelöscht werden.',
  'svc.timeEntryNotFound': 'Der Zeiteintrag wurde nicht gefunden.',
  'svc.timeTrackingLocked': 'Die Zeiterfassung für diesen Zeitraum ist als fertig markiert.',
  'svc.pickTimeEntries': 'Wähle mindestens einen nicht abgerechneten Zeiteintrag.',
  'svc.timesheetInvoiceDescription': 'Stunden für {project} im Zeitraum {from} – {to}.',
});
